import React from 'react';
import { Box, IconButton, Typography, Menu } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { ElvisConnectDash } from 'components/svg/ElvisConnectDash';
import { EurofinsLogoDash } from 'components/svg/EurofinsLogoDash';
import { NavigationContent } from './NavigationContent';

interface MobileHeaderProps {
  anchorElNav: HTMLElement | null;
  handleOpenNavMenu: (event: React.MouseEvent<HTMLElement>) => void;
  handleCloseNavMenu: () => void;
  navigationProps: any;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  anchorElNav,
  handleOpenNavMenu,
  handleCloseNavMenu,
  navigationProps
}) => {
  return (
    <>
      <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
        <div style={{ backgroundColor: '#fff', borderRadius: '40px' }}>
          <ElvisConnectDash />
        </div>
        <IconButton
          size="large"
          aria-label="navigation menu"
          onClick={handleOpenNavMenu}
          color="primary"
        >
          <MenuIcon />
        </IconButton>
        
        <Menu
          anchorEl={anchorElNav}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          keepMounted
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{ 
            display: { xs: 'block', md: 'none' },
            '& .MuiPaper-root': {
              backgroundColor: '#003883'
            }
          }}
        >
          <NavigationContent {...navigationProps} isMobile={true} />
        </Menu>
      </Box>

      <Typography
        variant="h6"
        noWrap
        component="div"
        sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
      >
        <EurofinsLogoDash />
      </Typography>
    </>
  );
};